import { defineComponent as u, ref as y, computed as i } from "vue";
import { i as c } from "./constants-ByXK9fg4.mjs";
import { O as h } from "./OrLoader-2SaTMxmZ.mjs";
var r = /* @__PURE__ */ ((e) => (e.Contained = "contained", e.Outlined = "outlined", e.Text = "text", e.Link = "link", e))(r || {}), a = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.Danger = "danger", e.Inherit = "inherit", e))(a || {}), o = /* @__PURE__ */ ((e) => (e.Button = "button", e.Submit = "submit", e.Reset = "reset", e))(o || {});
const k = [
  // Layout
  "layout-inline-row",
  // Overflow
  "overflow-hidden",
  // Interactivity
  "interactivity-click",
  // Shape
  "rounded-md",
  // Typography
  "typography-button"
], p = {
  [r.Contained]: [
    //  Layout
    "layout-inline-row justify-center",
    // Box
    "min-w-[96px]",
    // Spacing
    "px-md md:px-md",
    "py-sm+ md:py-sm"
  ],
  [r.Outlined]: [
    //  Layout
    "layout-inline-row justify-center",
    // Box
    "min-w-[96px]",
    // Spacing
    "px-md* md:px-md*",
    "py-sm+* md:py-sm*"
  ],
  [r.Text]: [
    //  Layout
    "layout-inline-row justify-center",
    // Box
    "min-w-[96px]",
    // Spacing
    "px-md md:px-md",
    "py-sm+ md:py-sm"
  ],
  [r.Link]: [
    //  Layout
    "layout-inline-row justify-center"
  ]
}, v = {
  [r.Contained]: [
    //  Layout
    "layout-inline-row",
    "gap-sm+ md:gap-sm"
  ],
  [r.Outlined]: [
    //  Layout
    "layout-inline-row",
    "gap-sm+ md:gap-sm"
  ],
  [r.Text]: [
    //  Layout
    "layout-inline-row",
    "gap-sm+ md:gap-sm"
  ],
  [r.Link]: [
    //  Layout
    "layout-inline-row",
    // Spacing
    "gap-xs"
  ]
}, f = {
  "primary-contained": [
    // Theme
    "theme-preset-1-primary",
    "dark:theme-preset-1-primary-dark",
    // Elevation (enabled)
    "enabled:shadow-button",
    "dark:enabled:shadow-button-dark"
  ],
  "danger-contained": [
    // Theme
    "theme-preset-1-error",
    "dark:theme-preset-1-error-dark",
    // Elevation (enabled)
    "enabled:shadow-button",
    "dark:enabled:shadow-button-dark"
  ],
  "inherit-contained": [
    // Elevation (enabled)
    "enabled:shadow-button",
    "dark:enabled:shadow-button-dark"
  ],
  "primary-outlined": [
    // Theme
    "theme-preset-3-primary",
    "dark:theme-preset-3-primary-dark",
    "theme-border-outline border-1",
    "dark:theme-border-outline-dark",
    // Theme (active)
    "active:theme-border-primary active:border-1",
    "dark:active:theme-border-primary-dark"
  ],
  "danger-outlined": [
    // Theme
    "theme-preset-3-error",
    "dark:theme-preset-3-error-dark",
    "theme-border-error border-1",
    "dark:theme-border-error-dark"
  ],
  "inherit-outlined": [],
  "primary-text": [
    // Theme
    "theme-preset-4-primary",
    "dark:theme-preset-4-primary-dark"
  ],
  "danger-text": [
    // Theme
    "theme-preset-4-error",
    "dark:theme-preset-4-error-dark"
  ],
  "inherit-text": [
    // Theme
    "theme-foreground-inherit",
    "dark:theme-foreground-inherit-dark"
  ],
  "primary-link": [
    // Theme
    "theme-preset-4-primary",
    "dark:theme-preset-4-primary-dark"
  ],
  "danger-link": [
    // Theme
    "theme-preset-4-error",
    "dark:theme-preset-4-error-dark"
  ],
  "inherit-link": [
    // Theme
    "theme-foreground-inherit",
    "dark:theme-foreground-inherit-dark",
    // Theme (activated)
    "activated:theme-foreground-default",
    "dark:activated:theme-foreground-default-dark"
  ]
}, g = {
  "primary-contained": [
    "interactivity-none",
    "bg-primary-hover dark:bg-primary-hover-dark"
  ],
  "danger-contained": [
    "interactivity-none",
    "bg-error-hover dark:bg-error-hover-dark"
  ],
  "inherit-contained": [
    "interactivity-none"
  ],
  "primary-outlined": [
    "interactivity-none"
  ],
  "danger-outlined": [
    "interactivity-none"
  ],
  "inherit-outlined": [
    "interactivity-none"
  ],
  "primary-text": [
    "interactivity-none",
    "text-primary-hover dark:text-primary-hover-dark"
  ],
  "danger-text": [
    "interactivity-none",
    "text-error-hover dark:text-error-hover-dark"
  ],
  "inherit-text": [
    "interactivity-none"
  ],
  "primary-link": [
    "interactivity-none",
    "text-primary-hover dark:text-primary-hover-dark"
  ],
  "danger-link": [
    "interactivity-none",
    "text-error-hover dark:text-error-hover-dark"
  ],
  "inherit-link": [
    "interactivity-none"
  ]
}, b = {
  contained: [
    // Position
    "relative",
    "flex",
    // Box
    "w-full",
    "h-full",
    // Aligment
    "items-center",
    "justify-center"
  ],
  outlined: [
    // Position
    "relative",
    "flex",
    // Box
    "w-full",
    "h-full",
    // Aligment
    "items-center",
    "justify-center"
  ],
  text: [
    // Position
    "relative",
    "flex",
    // Box
    "w-full",
    "h-full",
    // Aligment
    "items-center",
    "justify-center"
  ],
  link: [
    "contents"
  ]
}, x = {
  contained: [
    "invisible"
  ],
  outlined: [
    "invisible"
  ],
  text: [
    "hidden"
  ],
  link: [
    "hidden"
  ]
}, L = u({
  name: "OrButton",
  components: {
    OrLoader: h
  },
  props: {
    type: {
      type: String,
      default: () => o.Button
    },
    variant: {
      type: String,
      default: () => r.Contained
    },
    color: {
      type: String,
      default: () => a.Primary
    },
    activated: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    loadingText: {
      type: String,
      default: "Loading"
    }
  },
  emits: [
    "click",
    "focus",
    "blur"
  ],
  expose: [
    "root"
  ],
  setup(e, { emit: n }) {
    const d = y(), l = i(() => [
      "or-button-v3",
      ...k,
      ...p[e.variant],
      ...f[`${e.color}-${e.variant}`],
      ...e.loading ? g[`${e.color}-${e.variant}`] : []
    ]), m = i(() => [
      ...v[e.variant],
      ...e.loading ? b[e.variant] : []
    ]), s = i(() => [
      "contents",
      ...e.loading ? x[e.variant] : []
    ]);
    return {
      root: d,
      rootStyles: l,
      contentStyles: s,
      contentContainerStyles: m,
      isVue3: c,
      onClick: (t) => n("click", t),
      onFocus: (t) => n("focus", t),
      onBlur: (t) => n("blur", t)
    };
  }
});
export {
  r as B,
  L as _,
  a,
  o as b
};
//# sourceMappingURL=OrButton.vue_vue_type_script_lang-W1ictbKz.mjs.map
